var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFD5B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.818 10.8891C22.5754 9.13173 25.4246 9.13173 27.182 10.8891L37.1109 20.818C38.8683 22.5754 38.8683 25.4246 37.1109 27.182L27.182 37.1109C25.4246 38.8683 22.5754 38.8683 20.818 37.1109L10.8891 27.182C9.13173 25.4246 9.13173 22.5754 10.8891 20.818L20.818 10.8891Z",
    fill: "white",
    stroke: "#FF964A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 18.5C19.5 17.3954 20.3954 16.5 21.5 16.5H26.5C27.6046 16.5 28.5 17.3954 28.5 18.5V21H29C29.5523 21 30 21.4477 30 22V29C30 29.5523 29.5523 30 29 30H19C18.4477 30 18 29.5523 18 29V22C18 21.4477 18.4477 21 19 21H19.5V18.5ZM21 21H27V19C27 18.4477 26.5523 18 26 18H22C21.4477 18 21 18.4477 21 19V21ZM25.5 25.5C25.5 26.3284 24.8284 27 24 27C23.1716 27 22.5 26.3284 22.5 25.5C22.5 24.6716 23.1716 24 24 24C24.8284 24 25.5 24.6716 25.5 25.5Z",
    fill: "#FF964A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9e2aef6218f286bdae6ee3363f405ea0.svg";
export { ForwardRef as ReactComponent };